import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_BudgetFormAccountableAccount = _resolveComponent("BudgetFormAccountableAccount")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_BudgetParameters = _resolveComponent("BudgetParameters")!
  const _component_BudgetFormFull = _resolveComponent("BudgetFormFull")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_tag_manager = _resolveComponent("tag-manager")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialog) = $event)),
      onValid: _ctx.valid,
      title: _ctx.stepTitle,
      validTitle: _ctx.validTitle,
      validLoading: _ctx.validLoading,
      "valid-disabled": !_ctx.validProcess,
      hideValid: !_ctx.validDisplay,
      "previous-display": _ctx.displayPrevious,
      onPrevious: _cache[8] || (_cache[8] = ($event: any) => (_ctx.previous())),
      prefixDataCy: "FullBudgetProcess-oss-dialog",
      "min-width": '100vw'
    }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_progress_linear, {
                  height: "10",
                  indeterminate: ""
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_card, {
              key: 1,
              style: {"background-color":"transparent"},
              elevation: "0",
              class: "mx-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "3" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: _ctx.budgetName,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.budgetName) = $event)),
                          density: "compact"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "2",
                      class: "pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oss_date_picker_filled, {
                          modelValue: _ctx.date,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.date) = $event)),
                          type: "month",
                          format: "MM/YYYY",
                          "text-field-readonly": false,
                          "hide-details": "auto",
                          onChangeDate: _ctx.onDateChanged
                        }, null, 8, ["modelValue", "onChangeDate"])
                      ]),
                      _: 1
                    }),
                    (_ctx.step !== 6)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "2",
                          class: "pl-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select_filled, {
                              modelValue: _ctx.selectedPartition,
                              "onUpdate:modelValue": [
                                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedPartition) = $event)),
                                _cache[3] || (_cache[3] = ($event: any) => (_ctx.initializeDefaultTag()))
                              ],
                              items: _ctx.partitionTags,
                              "item-value": "id",
                              density: "compact",
                              required: "",
                              "hide-details": "auto",
                              "prepend-inner-icon": "$fa-gear",
                              "onClick:prependInner": _ctx.openTagManager,
                              "item-title": (item) => item.name
                            }, null, 8, ["modelValue", "items", "onClick:prependInner", "item-title"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.displayReinitializationButton)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          class: "pl-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              class: "d-flex justify-end",
                              rounded: "",
                              elevation: "0",
                              onClick: _ctx.reinitialize
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.reinitializationText), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window, {
                  modelValue: _ctx.step,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step) = $event)),
                  touchless: "",
                  class: "elevation-0",
                  style: {"background":"transparent"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, { value: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { class: "py-0" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, {
                              subheader: "",
                              lines: "two"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item, {
                                  class: "oss-list-item mb-2 rounded-lg",
                                  onClick: _ctx.onClassicMethodChosen,
                                  "data-cy": "FullBudgetProcess-methode_clasique"
                                }, {
                                  append: _withCtx(() => [
                                    _createVNode(_component_v_btn_next)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                                        _createTextVNode("Méthode classique")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_list_item_subtitle, null, {
                                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                                        _createTextVNode("Recommandée pour un démarrage ou une estimation simple de votre budget sur plusieurs années")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_v_list_item, {
                                  class: "oss-list-item mb-2 rounded-lg",
                                  onClick: _ctx.onNM1MethodChosen
                                }, {
                                  append: _withCtx(() => [
                                    _createVNode(_component_v_btn_next)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                                        _createTextVNode("Méthode basée sur l'exercice N-1")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_list_item_subtitle, null, {
                                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                                        _createTextVNode("Recommandée pour avoir un budget précis sur 1 an")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, {
                          class: "py-0",
                          style: {"overflow-y":"auto"}
                        }, {
                          default: _withCtx(() => [
                            (!_ctx.selectedAccountingPeriod)
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 0,
                                  type: "error"
                                }, {
                                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                                    _createTextVNode(" Si aucune donnée n'apparaît, assurez-vous d'avoir bien sélectionné une période comptable, puis recommencez. ")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.formBfaa)
                              ? (_openBlock(), _createBlock(_component_BudgetFormAccountableAccount, {
                                  key: 1,
                                  chargesGroupingMode: _ctx.bffGenerationMode,
                                  formBfaa: _ctx.formBfaa
                                }, null, 8, ["chargesGroupingMode", "formBfaa"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: 3 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, {
                          class: "py-0",
                          style: {"overflow-y":"auto"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                                    _createElementVNode("div", {
                                      class: "body-1 px-2",
                                      style: {"text-align":"justify"}
                                    }, " Vous pouvez maintenant choisir comment regrouper vos lignes de charges de l'année précédente. ", -1),
                                    _createElementVNode("div", {
                                      class: "body-1 px-2",
                                      style: {"text-align":"justify"}
                                    }, " Vous pouvez les regrouper par compte comptable, ou bien par fournisseur. ", -1),
                                    _createElementVNode("div", {
                                      class: "body-1 px-2",
                                      style: {"text-align":"justify"}
                                    }, " Cela signifie qu'une seule ligne par type de montant (charge, activité, personnel) et par entreprise ou compte comptable sera créée dans votre budget. ", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_radio_group, {
                                  modelValue: _ctx.bffGenerationMode,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bffGenerationMode) = $event)),
                                  column: "",
                                  color: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_radio, {
                                      label: "Regroupement des lignes par entreprise",
                                      value: "TPC"
                                    }),
                                    _createVNode(_component_v_radio, {
                                      label: "Regroupement des lignes par compte comptable",
                                      value: "AA"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, {
                          class: "py-0",
                          style: {"overflow-y":"auto"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_BudgetParameters, { parameters: _ctx.parameters }, null, 8, ["parameters"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: 5 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { class: "py-0" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_BudgetFormFull, {
                              formBff: _ctx.formBff,
                              groupingMode: _ctx.bffGenerationMode,
                              date: _ctx.date,
                              parameters: _ctx.parameters,
                              availableSalesAccounts: _ctx.availableSalesAccounts,
                              partitionTags: _ctx.partitionTags,
                              selectedPartition: _ctx.selectedPartition,
                              initializationPackage: _ctx.initializationPackage,
                              headersPackage: _ctx.headersPackage,
                              selectedCompany: _ctx.selectedCompany,
                              onValidationUpdate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onValidationUpdate($event)))
                            }, null, 8, ["formBff", "groupingMode", "date", "parameters", "availableSalesAccounts", "partitionTags", "selectedPartition", "initializationPackage", "headersPackage", "selectedCompany"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
      ]),
      _: 1
    }, 8, ["modelValue", "onValid", "title", "validTitle", "validLoading", "valid-disabled", "hideValid", "previous-display"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.displayTagManager,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.displayTagManager) = $event)),
      title: "Gestionnaire d'étiquettes",
      onClose: _ctx.getCreatedPartitionTags
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tag_manager)
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"])
  ], 64))
}